module.exports = __webpack_public_path__ + "static/media/mapfre-economics-red-bg.61d6dfa3.jpg";